import { createContext, useContext } from 'react';
import { type CanvasBinding, type CanvasRoots, TOP_LEVEL_BINDING, canvasRoots } from '../canvas-roots';
import { useCanvasDoc } from './canvas-doc-context';

/** Where the canvas's Yjs roots live. Defaults to top-level (standalone canvas). */
export const CanvasBindingContext = createContext<CanvasBinding>(TOP_LEVEL_BINDING);

export const useCanvasBinding = (): CanvasBinding => useContext(CanvasBindingContext);

/**
 * Convenience hook for consumers that have neither the doc nor the binding as a
 * param — resolves the canvas roots from the surrounding CanvasDocContext +
 * CanvasBindingContext. Throws if mounted outside a CanvasDocContext provider.
 */
export const useCanvasRoots = (): CanvasRoots => {
  const doc = useCanvasDoc();
  if (!doc) {
    throw new Error('useCanvasRoots must be used within a CanvasDocContext provider');
  }
  return canvasRoots(doc, useCanvasBinding());
};
